<template lang="html">
  <div class="tab-previewer">
    <div class="container content-bg tabs-container">
      <div class="tabs">
        <div
          v-for="(item, index) in items"
          class="tab tab-heading"
          :class="{'is-active': index === activeIndex}"
          :key="`tab-heading-${index}`"
          @click="slideToTab(index)"
        >
          <h3 @click="highlightField('tab heading')">{{ parse(item).tab_heading }}</h3>
        </div>
      </div>

      <div class="tab-container" ref="tabPreview" :style="{height: tabHeight}">
        <div
          class="tab-inner"
          :style="{width: containerWidth, transform: transform}"
        >
          <div
            class="tab"
            v-for="(item, index) in items"
            @click="highlightField('content')"
            :key="`tab-content-${index}`"
          >
            <div v-html="parse(item).content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'Tabs',

  mixins: [parseComponent],

  data() {
    return {
      transform: '0%',
      activeIndex: 0,
      tabHeight: ''
    }
  },

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    totalTabs() {
      return this.items.length
    },

    containerWidth() {
      return 100 * this.totalTabs + '%'
    },

    itemWidth() {
      return 100 / this.totalTabs
    }
  },

  methods: {
    slideToTab(index) {
      this.activeIndex = index
      this.transform = `translateX(-${this.itemWidth * index}%)`
      this.setHeight(index)
    },

    setHeight(index) {
      const padding = 20
      let tabs = this.$refs.tabPreview.querySelectorAll('.tab-inner .tab')
      let activeTabHeight = tabs[index].children[0].offsetHeight

      this.tabHeight = `${activeTabHeight + padding}px`
    }
  },

  mounted() {
    window.setTimeout(() => {
      const firstTab = 0
      this.setHeight(firstTab)
    }, 1000)
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'

.tab-previewer
  .tabs-container
    .tabs
      position: relative
      display: flex
      justify-content: flex-start
      margin-bottom: $gap-medium
      border-bottom: 2px solid
      padding-bottom: $gap-small
      position: sticky
      top: 0
      z-index: 1

      &:before
        display: none!important

    .tab-heading
      text-align: center
      opacity: 0.25
      cursor: pointer
      transition: opacity .3s ease-in-out
      text-transform: uppercase

      &.is-active
        position: relative
        opacity: 1

        @include themify($themes)
          color: themed('color-secondary')

    .tab-container
      overflow: hidden
      transition: height .3s ease-in-out

    .tab-data
      width: 100%
      padding: 0

      ul
        padding: 0
        list-style: none
        margin-top: 0

        li
          display: flex
          justify-content: flex-start
          margin: 0 0 $gap-small 0

          &.tab-item
            display: none

    .key
      text-transform: capitalize

    .value
      font-weight: bold
      margin-left: $gap-small

    .tab-inner
      transition: transform .5s ease-in-out
      display: flex

  .tab
    width: 100%
</style>
